// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      :host {
        display: block;
        color: #253750;
        font-size: 12px;
      }
      .dialog-header {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        padding: 4px 24px 18px;
        border-bottom: 1px solid #edf1f6;
        align-items: center;
      }
      .dialog-header h2 {
        margin: 0;
        padding: 0;
        font-size: 17px;
        font-weight: 600;
        line-height: 24px;
      }
      .dialog-header p {
        margin: 5px 0 0;
        color: #7d8a9d;
        font-size: 12px;
      }
      .icon-button {
        display: grid;
        place-items: center;
        width: 28px;
        height: 28px;
        border: 0;
        border-radius: 7px;
        background: transparent;
        color: #7d8a9d;
        cursor: pointer;
      }
      .icon-button:hover {
        color: var(--primary-color);
        background: color-mix(in srgb, var(--primary-color) 6%, white);
      }
      .icon-button span {
        font-size: 20px;
      }
      .dialog-content {
        margin: 0;
        padding: 0;
      }
      .table-scroll {
        overflow: auto;
        min-height: 160px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        text-align: start;
      }
      th {
        padding: 11px 18px;
        background: #fbfcfe;
        color: #7d8a9d;
        font-size: 10px;
        font-weight: 500;
        white-space: nowrap;
      }
      td {
        padding: 13px 18px;
        border-top: 1px solid #edf1f6;
        color: #53647a;
      }
      td:first-child {
        color: var(--primary-color);
        font-weight: 500;
      }
      .state-message {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: 160px;
        color: #8491a3;
      }
      .state-message span {
        font-size: 23px;
      }
      .dialog-footer {
        justify-content: flex-end;
        min-height: 0;
        margin: 0;
        padding: 12px 18px;
        border-top: 1px solid #edf1f6;
      }
      .paginator {
        font-size: 11px;
      }
      @media (max-width: 550px) {
        .dialog-header {
          padding-inline: 16px;
        }
        th,
        td {
          padding-inline: 14px;
        }
      }
    `, "",{"version":3,"sources":["webpack://./src/app/components/marketplace-dashboard/vat-history-dialog.component.ts"],"names":[],"mappings":";MACM;QACE,cAAc;QACd,cAAc;QACd,eAAe;MACjB;MACA;QACE,aAAa;QACb,8BAA8B;QAC9B,SAAS;QACT,sBAAsB;QACtB,gCAAgC;QAChC,mBAAmB;MACrB;MACA;QACE,SAAS;QACT,UAAU;QACV,eAAe;QACf,gBAAgB;QAChB,iBAAiB;MACnB;MACA;QACE,eAAe;QACf,cAAc;QACd,eAAe;MACjB;MACA;QACE,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,uBAAuB;QACvB,cAAc;QACd,eAAe;MACjB;MACA;QACE,2BAA2B;QAC3B,8DAA8D;MAChE;MACA;QACE,eAAe;MACjB;MACA;QACE,SAAS;QACT,UAAU;MACZ;MACA;QACE,cAAc;QACd,iBAAiB;MACnB;MACA;QACE,WAAW;QACX,yBAAyB;QACzB,iBAAiB;MACnB;MACA;QACE,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,mBAAmB;MACrB;MACA;QACE,kBAAkB;QAClB,6BAA6B;QAC7B,cAAc;MAChB;MACA;QACE,2BAA2B;QAC3B,gBAAgB;MAClB;MACA;QACE,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,iBAAiB;QACjB,cAAc;MAChB;MACA;QACE,eAAe;MACjB;MACA;QACE,yBAAyB;QACzB,aAAa;QACb,SAAS;QACT,kBAAkB;QAClB,6BAA6B;MAC/B;MACA;QACE,eAAe;MACjB;MACA;QACE;UACE,oBAAoB;QACtB;QACA;;UAEE,oBAAoB;QACtB;MACF","sourcesContent":["\n      :host {\n        display: block;\n        color: #253750;\n        font-size: 12px;\n      }\n      .dialog-header {\n        display: flex;\n        justify-content: space-between;\n        gap: 16px;\n        padding: 4px 24px 18px;\n        border-bottom: 1px solid #edf1f6;\n        align-items: center;\n      }\n      .dialog-header h2 {\n        margin: 0;\n        padding: 0;\n        font-size: 17px;\n        font-weight: 600;\n        line-height: 24px;\n      }\n      .dialog-header p {\n        margin: 5px 0 0;\n        color: #7d8a9d;\n        font-size: 12px;\n      }\n      .icon-button {\n        display: grid;\n        place-items: center;\n        width: 28px;\n        height: 28px;\n        border: 0;\n        border-radius: 7px;\n        background: transparent;\n        color: #7d8a9d;\n        cursor: pointer;\n      }\n      .icon-button:hover {\n        color: var(--primary-color);\n        background: color-mix(in srgb, var(--primary-color) 6%, white);\n      }\n      .icon-button span {\n        font-size: 20px;\n      }\n      .dialog-content {\n        margin: 0;\n        padding: 0;\n      }\n      .table-scroll {\n        overflow: auto;\n        min-height: 160px;\n      }\n      table {\n        width: 100%;\n        border-collapse: collapse;\n        text-align: start;\n      }\n      th {\n        padding: 11px 18px;\n        background: #fbfcfe;\n        color: #7d8a9d;\n        font-size: 10px;\n        font-weight: 500;\n        white-space: nowrap;\n      }\n      td {\n        padding: 13px 18px;\n        border-top: 1px solid #edf1f6;\n        color: #53647a;\n      }\n      td:first-child {\n        color: var(--primary-color);\n        font-weight: 500;\n      }\n      .state-message {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        min-height: 160px;\n        color: #8491a3;\n      }\n      .state-message span {\n        font-size: 23px;\n      }\n      .dialog-footer {\n        justify-content: flex-end;\n        min-height: 0;\n        margin: 0;\n        padding: 12px 18px;\n        border-top: 1px solid #edf1f6;\n      }\n      .paginator {\n        font-size: 11px;\n      }\n      @media (max-width: 550px) {\n        .dialog-header {\n          padding-inline: 16px;\n        }\n        th,\n        td {\n          padding-inline: 14px;\n        }\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
